import React, { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Box } from '@mui/material';
import { Typography, Checkbox, Button, Avatar, colors } from '@leapeasy/ui-kit';

import AlertDialog from 'components/AlertDialog';
import { submitFormAction } from 'redux/actions/shortFormActions';

const cardStyle = {
  padding: '12px',
  background: 'rgba(249, 248, 249, 0.8)',
  border: '1px solid #F8F4F9',
  borderRadius: '12px',
  gap: '12px',
  display: 'flex',
  flexDirection: 'column',
};
const contentStyle = {
  padding: '24px',
  border: '1px solid #F8F4F9',
  borderRadius: '12px',
  gap: '10px',
  background: 'white',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  flexWrap: 'wrap',
};
const itemStyle = {
  width: '50%',
  flexGrow: 0,
  flexShrink: 0,
  borderRight: '1px solid #E8D6EB',
  boxSizing: 'border-box',
  paddingRight: '12px',
};

const Form8 = (props) => {
  const { handleNext, handleBack, handleStep } = props;

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.shortFormData);
  const [open, setOpen] = useState(false);
  const [termCheck, setTermCheck] = useState(false);

  const handleOk = () => {
    dispatch(submitFormAction(formData.data));
    setOpen(false);
    handleNext();
  };

  const handleSubmit = () => {
    setOpen(true);
  };

  return (
    <Fragment>
      <Box display="flex" flexDirection="column" gap="20px">
        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="1" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Personal Information
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(0)}
            />
          </Box>

          <Box sx={contentStyle}>
            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  First Name
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.fname}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Last Name
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.lname}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Contact Email
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{
                    color: colors.purple[900],
                    marginTop: '8px',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  {formData.data.email}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Contact Phone Number
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{
                    color: colors.purple[900],
                    marginTop: '8px',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  {formData.data.phone}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Date Of Birth
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.birthDate}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Full-Time Student?
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.isStudent ? 'Yes' : 'No'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Lease Detail
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(1)}
            />
          </Box>

          <Box sx={contentStyle}>
            <Box>
              <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                U.S. Citizen or Permanent Resident?
              </Typography>
              <Typography
                variant="cta-xs"
                style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
              >
                {formData.data.isCitizen ? 'Yes' : 'No'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Your Current Address
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(2)}
            />
          </Box>
          <Box sx={contentStyle}>
            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Street
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentStreet}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Unit (Optional)
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentUnit}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  City
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentCity}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  State/Province
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentState}
                </Typography>
              </Box>
            </Box>

            <Box display="flex">
              <Box sx={itemStyle}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  PostalCode
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentPostalCode}
                </Typography>
              </Box>

              <Box sx={{ paddingLeft: '12px' }}>
                <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                  Country
                </Typography>
                <Typography
                  variant="cta-xs"
                  style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                >
                  {formData.data.currentCountry}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={cardStyle}>
          <Box display="flex" alignItems="center" gap="12px">
            <Avatar size="medium" iconLabel="2" state="none" />

            <Typography variant="body1" style={{ fontWeight: '700' }}>
              Identity Information
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Button
              variant="icon"
              size="small"
              iconPrefix="EditorLayout.Edit"
              onClick={() => handleStep(3)}
            />
          </Box>

          <Box sx={contentStyle}>
            {(!formData.data.isStudent && (
              <>
                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Highest Education Achieved
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.education}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Evicted Record
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.eviction === false ? 'No' : 'Yes'}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Employed Status
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.employment}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Available Cash
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      <b>$</b>
                      {formData.data.cash}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex">
                  {((formData.data.employment === 'Employed' ||
                    formData.data.employment === 'Self-Employed' ||
                    formData.data.employment === 'Retired') && (
                    <>
                      <Box sx={itemStyle}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          Employment Start Date
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                        >
                          {formData.data.employmentStartDate}
                        </Typography>
                      </Box>

                      <Box sx={{ paddingLeft: '12px' }}>
                        <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                          Annual Income
                        </Typography>
                        <Typography
                          variant="cta-xs"
                          style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                        >
                          <b>$</b>
                          {formData.data.annualIncome}
                        </Typography>
                      </Box>
                    </>
                  )) || (
                    <Box>
                      <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                        Annual Income
                      </Typography>
                      <Typography
                        variant="cta-xs"
                        style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                      >
                        <b>$</b>
                        {formData.data.annualIncome}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </>
            )) || (
              <>
                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Year of School during Lease
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.schoolyear}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Highest Education Achieved
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.education}
                    </Typography>
                  </Box>
                </Box>

                <Box display="flex">
                  <Box sx={itemStyle}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      Evicted Record
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.eviction === false ? 'No' : 'Yes'}
                    </Typography>
                  </Box>

                  <Box sx={{ paddingLeft: '12px' }}>
                    <Typography variant="cta-xs" style={{ color: '#A39AA9' }}>
                      GPA
                    </Typography>
                    <Typography
                      variant="cta-xs"
                      style={{ color: colors.purple[900], marginTop: '8px', fontWeight: '500' }}
                    >
                      {formData.data.gpa}
                    </Typography>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        </Box>
      </Box>

      <Box display="flex" gap="12px" alignItems="center" mt={2}>
        <Checkbox value={termCheck || false} onChange={(val) => setTermCheck(val)} />

        <Typography variant="small" style={{ color: colors.purple[900] }}>
          Agree with&nbsp;
          <a
            href="https://www.leapeasy.com/leap-lease-program-terms-conditions/"
            target="_blank"
            color="primary"
            style={{ color: colors.purple[700] }}
          >
            Terms & Conditions
          </a>
        </Typography>
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button size="medium" variant="secondary" onClick={handleBack} style={{ flexShrink: 2 }}>
          Back
        </Button>

        <Button
          size="medium"
          onClick={() => handleSubmit()}
          disabled={!termCheck}
          style={{ flexShrink: 1 }}
        >
          Next
        </Button>
      </Box>

      <AlertDialog
        open={open}
        data={formData}
        handleClose={() => setOpen(false)}
        handleOk={handleOk}
      />
    </Fragment>
  );
};

export default Form8;
